/* rails-erb-loader-dependencies api_maker/resources/ models/ */

import {digg} from "diggerize"
import ModelRecipesLoader from "@kaspernj/api-maker/build/model-recipes-loader.js"
import modelRecipes from "./model-recipes.json"

const loader = new ModelRecipesLoader({recipes: modelRecipes})
const result = loader.load()



  

  const AccountAuditModelClass = digg(result, "AccountAudit")

  class AccountAudit extends AccountAuditModelClass {}

  

  const AccountModelClass = digg(result, "Account")

  class Account extends AccountModelClass {}

  

  const AccountSchoolAuditModelClass = digg(result, "AccountSchoolAudit")

  class AccountSchoolAudit extends AccountSchoolAuditModelClass {}

  

  const AccountSchoolModelClass = digg(result, "AccountSchool")

  class AccountSchool extends AccountSchoolModelClass {}

  

  const AccountUserAuditModelClass = digg(result, "AccountUserAudit")

  class AccountUserAudit extends AccountUserAuditModelClass {}

  

  const AccountUserModelClass = digg(result, "AccountUser")

  class AccountUser extends AccountUserModelClass {}

  

  const AuditActionModelClass = digg(result, "AuditAction")

  class AuditAction extends AuditActionModelClass {}

  

  const AuditAuditableTypeModelClass = digg(result, "AuditAuditableType")

  class AuditAuditableType extends AuditAuditableTypeModelClass {}

  

  const AuditModelClass = digg(result, "Audit")

  class Audit extends AuditModelClass {}

  

  const BrainBreakAuditModelClass = digg(result, "BrainBreakAudit")

  class BrainBreakAudit extends BrainBreakAuditModelClass {}

  

  const BrainBreakClassStepAuditModelClass = digg(result, "BrainBreakClassStepAudit")

  class BrainBreakClassStepAudit extends BrainBreakClassStepAuditModelClass {}

  

  const BrainBreakClassStepModelClass = digg(result, "BrainBreakClassStep")

  class BrainBreakClassStep extends BrainBreakClassStepModelClass {}

  

  const BrainBreakModelClass = digg(result, "BrainBreak")

  class BrainBreak extends BrainBreakModelClass {}

  

  const ChallengeAuditModelClass = digg(result, "ChallengeAudit")

  class ChallengeAudit extends ChallengeAuditModelClass {}

  

  const ChallengeClassStepAuditModelClass = digg(result, "ChallengeClassStepAudit")

  class ChallengeClassStepAudit extends ChallengeClassStepAuditModelClass {}

  

  const ChallengeClassStepModelClass = digg(result, "ChallengeClassStep")

  class ChallengeClassStep extends ChallengeClassStepModelClass {}

  

  const ChallengeModelClass = digg(result, "Challenge")

  class Challenge extends ChallengeModelClass {}

  

  const CheckInAuditModelClass = digg(result, "CheckInAudit")

  class CheckInAudit extends CheckInAuditModelClass {}

  

  const CheckInClassStepAuditModelClass = digg(result, "CheckInClassStepAudit")

  class CheckInClassStepAudit extends CheckInClassStepAuditModelClass {}

  

  const CheckInClassStepModelClass = digg(result, "CheckInClassStep")

  class CheckInClassStep extends CheckInClassStepModelClass {}

  

  const CheckInModelClass = digg(result, "CheckIn")

  class CheckIn extends CheckInModelClass {}

  

  const ClassStatusExpansionAuditModelClass = digg(result, "ClassStatusExpansionAudit")

  class ClassStatusExpansionAudit extends ClassStatusExpansionAuditModelClass {}

  

  const ClassStatusExpansionModelClass = digg(result, "ClassStatusExpansion")

  class ClassStatusExpansion extends ClassStatusExpansionModelClass {}

  

  const ClassStepAuditModelClass = digg(result, "ClassStepAudit")

  class ClassStepAudit extends ClassStepAuditModelClass {}

  

  const ClassStepModelClass = digg(result, "ClassStep")

  class ClassStep extends ClassStepModelClass {}

  

  const ContactAuditModelClass = digg(result, "ContactAudit")

  class ContactAudit extends ContactAuditModelClass {}

  

  const ContactEmailAuditModelClass = digg(result, "ContactEmailAudit")

  class ContactEmailAudit extends ContactEmailAuditModelClass {}

  

  const ContactEmailModelClass = digg(result, "ContactEmail")

  class ContactEmail extends ContactEmailModelClass {}

  

  const ContactPhoneNumberAuditModelClass = digg(result, "ContactPhoneNumberAudit")

  class ContactPhoneNumberAudit extends ContactPhoneNumberAuditModelClass {}

  

  const ContactPhoneNumberModelClass = digg(result, "ContactPhoneNumber")

  class ContactPhoneNumber extends ContactPhoneNumberModelClass {}

  

  const ContactPointAuditModelClass = digg(result, "ContactPointAudit")

  class ContactPointAudit extends ContactPointAuditModelClass {}

  

  const ContactPointModelClass = digg(result, "ContactPoint")

  class ContactPoint extends ContactPointModelClass {}

  

  const ContactRelationshipAuditModelClass = digg(result, "ContactRelationshipAudit")

  class ContactRelationshipAudit extends ContactRelationshipAuditModelClass {}

  

  const ContactRelationshipModelClass = digg(result, "ContactRelationship")

  class ContactRelationship extends ContactRelationshipModelClass {}

  

  const ContactRelationshipTypeAuditModelClass = digg(result, "ContactRelationshipTypeAudit")

  class ContactRelationshipTypeAudit extends ContactRelationshipTypeAuditModelClass {}

  

  const ContactRelationshipTypeModelClass = digg(result, "ContactRelationshipType")

  class ContactRelationshipType extends ContactRelationshipTypeModelClass {}

  

  const ContactModelClass = digg(result, "Contact")

  class Contact extends ContactModelClass {}

  

  const ContactTypeAuditModelClass = digg(result, "ContactTypeAudit")

  class ContactTypeAudit extends ContactTypeAuditModelClass {}

  

  const ContactTypeModelClass = digg(result, "ContactType")

  class ContactType extends ContactTypeModelClass {}

  

  const ContentAbsoluteContainerAuditModelClass = digg(result, "ContentAbsoluteContainerAudit")

  class ContentAbsoluteContainerAudit extends ContentAbsoluteContainerAuditModelClass {}

  

  const ContentAbsoluteContainerModelClass = digg(result, "ContentAbsoluteContainer")

  class ContentAbsoluteContainer extends ContentAbsoluteContainerModelClass {}

  

  const ContentAuditModelClass = digg(result, "ContentAudit")

  class ContentAudit extends ContentAuditModelClass {}

  

  const ContentPieceTypeAuditModelClass = digg(result, "ContentPieceTypeAudit")

  class ContentPieceTypeAudit extends ContentPieceTypeAuditModelClass {}

  

  const ContentPieceTypeModelClass = digg(result, "ContentPieceType")

  class ContentPieceType extends ContentPieceTypeModelClass {}

  

  const ContentModelClass = digg(result, "Content")

  class Content extends ContentModelClass {}

  

  const CountryAuditModelClass = digg(result, "CountryAudit")

  class CountryAudit extends CountryAuditModelClass {}

  

  const CountryModelClass = digg(result, "Country")

  class Country extends CountryModelClass {}

  

  const CountryStateAuditModelClass = digg(result, "CountryStateAudit")

  class CountryStateAudit extends CountryStateAuditModelClass {}

  

  const CountryStateModelClass = digg(result, "CountryState")

  class CountryState extends CountryStateModelClass {}

  

  const CourseAuditModelClass = digg(result, "CourseAudit")

  class CourseAudit extends CourseAuditModelClass {}

  

  const CourseClassStepAuditModelClass = digg(result, "CourseClassStepAudit")

  class CourseClassStepAudit extends CourseClassStepAuditModelClass {}

  

  const CourseClassStepModelClass = digg(result, "CourseClassStep")

  class CourseClassStep extends CourseClassStepModelClass {}

  

  const CourseGroupAuditModelClass = digg(result, "CourseGroupAudit")

  class CourseGroupAudit extends CourseGroupAuditModelClass {}

  

  const CourseGroupCourseAuditModelClass = digg(result, "CourseGroupCourseAudit")

  class CourseGroupCourseAudit extends CourseGroupCourseAuditModelClass {}

  

  const CourseGroupCourseModelClass = digg(result, "CourseGroupCourse")

  class CourseGroupCourse extends CourseGroupCourseModelClass {}

  

  const CourseGroupModelClass = digg(result, "CourseGroup")

  class CourseGroup extends CourseGroupModelClass {}

  

  const CourseModuleAuditModelClass = digg(result, "CourseModuleAudit")

  class CourseModuleAudit extends CourseModuleAuditModelClass {}

  

  const CourseModuleModelClass = digg(result, "CourseModule")

  class CourseModule extends CourseModuleModelClass {}

  

  const CourseModelClass = digg(result, "Course")

  class Course extends CourseModelClass {}

  

  const CurrencyAuditModelClass = digg(result, "CurrencyAudit")

  class CurrencyAudit extends CurrencyAuditModelClass {}

  

  const CurrencyModelClass = digg(result, "Currency")

  class Currency extends CurrencyModelClass {}

  

  const DialogueAuditModelClass = digg(result, "DialogueAudit")

  class DialogueAudit extends DialogueAuditModelClass {}

  

  const DialogueModelClass = digg(result, "Dialogue")

  class Dialogue extends DialogueModelClass {}

  

  const EmailTemplateAuditModelClass = digg(result, "EmailTemplateAudit")

  class EmailTemplateAudit extends EmailTemplateAuditModelClass {}

  

  const EmailTemplatePreviewAuditModelClass = digg(result, "EmailTemplatePreviewAudit")

  class EmailTemplatePreviewAudit extends EmailTemplatePreviewAuditModelClass {}

  

  const EmailTemplatePreviewLiquidVariableAuditModelClass = digg(result, "EmailTemplatePreviewLiquidVariableAudit")

  class EmailTemplatePreviewLiquidVariableAudit extends EmailTemplatePreviewLiquidVariableAuditModelClass {}

  

  const EmailTemplatePreviewLiquidVariableModelClass = digg(result, "EmailTemplatePreviewLiquidVariable")

  class EmailTemplatePreviewLiquidVariable extends EmailTemplatePreviewLiquidVariableModelClass {}

  

  const EmailTemplatePreviewModelClass = digg(result, "EmailTemplatePreview")

  class EmailTemplatePreview extends EmailTemplatePreviewModelClass {}

  

  const EmailTemplateModelClass = digg(result, "EmailTemplate")

  class EmailTemplate extends EmailTemplateModelClass {}

  

  const EvaluationGroupModelClass = digg(result, "EvaluationGroup")

  class EvaluationGroup extends EvaluationGroupModelClass {}

  

  const EvaluationRuleModelClass = digg(result, "EvaluationRule")

  class EvaluationRule extends EvaluationRuleModelClass {}

  

  const InvoiceAuditModelClass = digg(result, "InvoiceAudit")

  class InvoiceAudit extends InvoiceAuditModelClass {}

  

  const InvoiceInfoAuditModelClass = digg(result, "InvoiceInfoAudit")

  class InvoiceInfoAudit extends InvoiceInfoAuditModelClass {}

  

  const InvoiceInfoModelClass = digg(result, "InvoiceInfo")

  class InvoiceInfo extends InvoiceInfoModelClass {}

  

  const InvoiceLineAuditModelClass = digg(result, "InvoiceLineAudit")

  class InvoiceLineAudit extends InvoiceLineAuditModelClass {}

  

  const InvoiceLineModelClass = digg(result, "InvoiceLine")

  class InvoiceLine extends InvoiceLineModelClass {}

  

  const InvoiceModelClass = digg(result, "Invoice")

  class Invoice extends InvoiceModelClass {}

  

  const LocaleAuditModelClass = digg(result, "LocaleAudit")

  class LocaleAudit extends LocaleAuditModelClass {}

  

  const LocaleModelClass = digg(result, "Locale")

  class Locale extends LocaleModelClass {}

  

  const NewsletterAuditModelClass = digg(result, "NewsletterAudit")

  class NewsletterAudit extends NewsletterAuditModelClass {}

  

  const NewsletterModelClass = digg(result, "Newsletter")

  class Newsletter extends NewsletterModelClass {}

  

  const NewsletterTemplateAuditModelClass = digg(result, "NewsletterTemplateAudit")

  class NewsletterTemplateAudit extends NewsletterTemplateAuditModelClass {}

  

  const NewsletterTemplateModelClass = digg(result, "NewsletterTemplate")

  class NewsletterTemplate extends NewsletterTemplateModelClass {}

  

  const NewsletterTemplateTableSearchAuditModelClass = digg(result, "NewsletterTemplateTableSearchAudit")

  class NewsletterTemplateTableSearchAudit extends NewsletterTemplateTableSearchAuditModelClass {}

  

  const NewsletterTemplateTableSearchModelClass = digg(result, "NewsletterTemplateTableSearch")

  class NewsletterTemplateTableSearch extends NewsletterTemplateTableSearchModelClass {}

  

  const NewsletterTemplateTimeZoneStateAuditModelClass = digg(result, "NewsletterTemplateTimeZoneStateAudit")

  class NewsletterTemplateTimeZoneStateAudit extends NewsletterTemplateTimeZoneStateAuditModelClass {}

  

  const NewsletterTemplateTimeZoneStateModelClass = digg(result, "NewsletterTemplateTimeZoneState")

  class NewsletterTemplateTimeZoneState extends NewsletterTemplateTimeZoneStateModelClass {}

  

  const NotificationAuditModelClass = digg(result, "NotificationAudit")

  class NotificationAudit extends NotificationAuditModelClass {}

  

  const NotificationModelClass = digg(result, "Notification")

  class Notification extends NotificationModelClass {}

  

  const NotificationSettingAuditModelClass = digg(result, "NotificationSettingAudit")

  class NotificationSettingAudit extends NotificationSettingAuditModelClass {}

  

  const NotificationSettingModelClass = digg(result, "NotificationSetting")

  class NotificationSetting extends NotificationSettingModelClass {}

  

  const NotificationTypeActionAuditModelClass = digg(result, "NotificationTypeActionAudit")

  class NotificationTypeActionAudit extends NotificationTypeActionAuditModelClass {}

  

  const NotificationTypeActionModelClass = digg(result, "NotificationTypeAction")

  class NotificationTypeAction extends NotificationTypeActionModelClass {}

  

  const NotificationTypeAuditModelClass = digg(result, "NotificationTypeAudit")

  class NotificationTypeAudit extends NotificationTypeAuditModelClass {}

  

  const NotificationTypeAuditTriggerAuditModelClass = digg(result, "NotificationTypeAuditTriggerAudit")

  class NotificationTypeAuditTriggerAudit extends NotificationTypeAuditTriggerAuditModelClass {}

  

  const NotificationTypeAuditTriggerModelClass = digg(result, "NotificationTypeAuditTrigger")

  class NotificationTypeAuditTrigger extends NotificationTypeAuditTriggerModelClass {}

  

  const NotificationTypeModelClass = digg(result, "NotificationType")

  class NotificationType extends NotificationTypeModelClass {}

  

  const PageContentAuditModelClass = digg(result, "PageContentAudit")

  class PageContentAudit extends PageContentAuditModelClass {}

  

  const PageContentModelClass = digg(result, "PageContent")

  class PageContent extends PageContentModelClass {}

  

  const PageViewAuditModelClass = digg(result, "PageViewAudit")

  class PageViewAudit extends PageViewAuditModelClass {}

  

  const PageViewModelClass = digg(result, "PageView")

  class PageView extends PageViewModelClass {}

  

  const PaymentMethodAuditModelClass = digg(result, "PaymentMethodAudit")

  class PaymentMethodAudit extends PaymentMethodAuditModelClass {}

  

  const PaymentMethodModelClass = digg(result, "PaymentMethod")

  class PaymentMethod extends PaymentMethodModelClass {}

  

  const PlanAuditModelClass = digg(result, "PlanAudit")

  class PlanAudit extends PlanAuditModelClass {}

  

  const PlanModelClass = digg(result, "Plan")

  class Plan extends PlanModelClass {}

  

  const PlanResourceAuditModelClass = digg(result, "PlanResourceAudit")

  class PlanResourceAudit extends PlanResourceAuditModelClass {}

  

  const PlanResourcePeriodAuditModelClass = digg(result, "PlanResourcePeriodAudit")

  class PlanResourcePeriodAudit extends PlanResourcePeriodAuditModelClass {}

  

  const PlanResourcePeriodPriceAuditModelClass = digg(result, "PlanResourcePeriodPriceAudit")

  class PlanResourcePeriodPriceAudit extends PlanResourcePeriodPriceAuditModelClass {}

  

  const PlanResourcePeriodPriceModelClass = digg(result, "PlanResourcePeriodPrice")

  class PlanResourcePeriodPrice extends PlanResourcePeriodPriceModelClass {}

  

  const PlanResourcePeriodModelClass = digg(result, "PlanResourcePeriod")

  class PlanResourcePeriod extends PlanResourcePeriodModelClass {}

  

  const PlanResourceModelClass = digg(result, "PlanResource")

  class PlanResource extends PlanResourceModelClass {}

  

  const RoleAuditModelClass = digg(result, "RoleAudit")

  class RoleAudit extends RoleAuditModelClass {}

  

  const RoleModelClass = digg(result, "Role")

  class Role extends RoleModelClass {}

  

  const SchoolAuditModelClass = digg(result, "SchoolAudit")

  class SchoolAudit extends SchoolAuditModelClass {}

  

  const SchoolClassAuditModelClass = digg(result, "SchoolClassAudit")

  class SchoolClassAudit extends SchoolClassAuditModelClass {}

  

  const SchoolClassBrainBreakAuditModelClass = digg(result, "SchoolClassBrainBreakAudit")

  class SchoolClassBrainBreakAudit extends SchoolClassBrainBreakAuditModelClass {}

  

  const SchoolClassBrainBreakModelClass = digg(result, "SchoolClassBrainBreak")

  class SchoolClassBrainBreak extends SchoolClassBrainBreakModelClass {}

  

  const SchoolClassChallengeAuditModelClass = digg(result, "SchoolClassChallengeAudit")

  class SchoolClassChallengeAudit extends SchoolClassChallengeAuditModelClass {}

  

  const SchoolClassChallengeModelClass = digg(result, "SchoolClassChallenge")

  class SchoolClassChallenge extends SchoolClassChallengeModelClass {}

  

  const SchoolClassCheckInAuditModelClass = digg(result, "SchoolClassCheckInAudit")

  class SchoolClassCheckInAudit extends SchoolClassCheckInAuditModelClass {}

  

  const SchoolClassCheckInEventAuditModelClass = digg(result, "SchoolClassCheckInEventAudit")

  class SchoolClassCheckInEventAudit extends SchoolClassCheckInEventAuditModelClass {}

  

  const SchoolClassCheckInEventModelClass = digg(result, "SchoolClassCheckInEvent")

  class SchoolClassCheckInEvent extends SchoolClassCheckInEventModelClass {}

  

  const SchoolClassCheckInModelClass = digg(result, "SchoolClassCheckIn")

  class SchoolClassCheckIn extends SchoolClassCheckInModelClass {}

  

  const SchoolClassContentPieceAuditModelClass = digg(result, "SchoolClassContentPieceAudit")

  class SchoolClassContentPieceAudit extends SchoolClassContentPieceAuditModelClass {}

  

  const SchoolClassContentPieceModelClass = digg(result, "SchoolClassContentPiece")

  class SchoolClassContentPiece extends SchoolClassContentPieceModelClass {}

  

  const SchoolClassCourseAuditModelClass = digg(result, "SchoolClassCourseAudit")

  class SchoolClassCourseAudit extends SchoolClassCourseAuditModelClass {}

  

  const SchoolClassCourseModuleAuditModelClass = digg(result, "SchoolClassCourseModuleAudit")

  class SchoolClassCourseModuleAudit extends SchoolClassCourseModuleAuditModelClass {}

  

  const SchoolClassCourseModuleModelClass = digg(result, "SchoolClassCourseModule")

  class SchoolClassCourseModule extends SchoolClassCourseModuleModelClass {}

  

  const SchoolClassCourseModelClass = digg(result, "SchoolClassCourse")

  class SchoolClassCourse extends SchoolClassCourseModelClass {}

  

  const SchoolClassGroupAuditModelClass = digg(result, "SchoolClassGroupAudit")

  class SchoolClassGroupAudit extends SchoolClassGroupAuditModelClass {}

  

  const SchoolClassGroupClassStepAuditModelClass = digg(result, "SchoolClassGroupClassStepAudit")

  class SchoolClassGroupClassStepAudit extends SchoolClassGroupClassStepAuditModelClass {}

  

  const SchoolClassGroupClassStepModelClass = digg(result, "SchoolClassGroupClassStep")

  class SchoolClassGroupClassStep extends SchoolClassGroupClassStepModelClass {}

  

  const SchoolClassGroupModelClass = digg(result, "SchoolClassGroup")

  class SchoolClassGroup extends SchoolClassGroupModelClass {}

  

  const SchoolClassInvitationAuditModelClass = digg(result, "SchoolClassInvitationAudit")

  class SchoolClassInvitationAudit extends SchoolClassInvitationAuditModelClass {}

  

  const SchoolClassInvitationModelClass = digg(result, "SchoolClassInvitation")

  class SchoolClassInvitation extends SchoolClassInvitationModelClass {}

  

  const SchoolClassModelClass = digg(result, "SchoolClass")

  class SchoolClass extends SchoolClassModelClass {}

  

  const SchoolContactRequestAuditModelClass = digg(result, "SchoolContactRequestAudit")

  class SchoolContactRequestAudit extends SchoolContactRequestAuditModelClass {}

  

  const SchoolContactRequestModelClass = digg(result, "SchoolContactRequest")

  class SchoolContactRequest extends SchoolContactRequestModelClass {}

  

  const SchoolModelClass = digg(result, "School")

  class School extends SchoolModelClass {}

  

  const ScoreFactorAuditModelClass = digg(result, "ScoreFactorAudit")

  class ScoreFactorAudit extends ScoreFactorAuditModelClass {}

  

  const ScoreFactorGroupAuditModelClass = digg(result, "ScoreFactorGroupAudit")

  class ScoreFactorGroupAudit extends ScoreFactorGroupAuditModelClass {}

  

  const ScoreFactorGroupModelClass = digg(result, "ScoreFactorGroup")

  class ScoreFactorGroup extends ScoreFactorGroupModelClass {}

  

  const ScoreFactorGroupScoreFactorAuditModelClass = digg(result, "ScoreFactorGroupScoreFactorAudit")

  class ScoreFactorGroupScoreFactorAudit extends ScoreFactorGroupScoreFactorAuditModelClass {}

  

  const ScoreFactorGroupScoreFactorModelClass = digg(result, "ScoreFactorGroupScoreFactor")

  class ScoreFactorGroupScoreFactor extends ScoreFactorGroupScoreFactorModelClass {}

  

  const ScoreFactorModelClass = digg(result, "ScoreFactor")

  class ScoreFactor extends ScoreFactorModelClass {}

  

  const StripeCardModelClass = digg(result, "StripeCard")

  class StripeCard extends StripeCardModelClass {}

  

  const StripeChargeModelClass = digg(result, "StripeCharge")

  class StripeCharge extends StripeChargeModelClass {}

  

  const StripeCouponModelClass = digg(result, "StripeCoupon")

  class StripeCoupon extends StripeCouponModelClass {}

  

  const StripeCustomerModelClass = digg(result, "StripeCustomer")

  class StripeCustomer extends StripeCustomerModelClass {}

  

  const StripeDiscountModelClass = digg(result, "StripeDiscount")

  class StripeDiscount extends StripeDiscountModelClass {}

  

  const StripeInvoiceItemModelClass = digg(result, "StripeInvoiceItem")

  class StripeInvoiceItem extends StripeInvoiceItemModelClass {}

  

  const StripeInvoiceModelClass = digg(result, "StripeInvoice")

  class StripeInvoice extends StripeInvoiceModelClass {}

  

  const StripePaymentIntentModelClass = digg(result, "StripePaymentIntent")

  class StripePaymentIntent extends StripePaymentIntentModelClass {}

  

  const StripePaymentMethodModelClass = digg(result, "StripePaymentMethod")

  class StripePaymentMethod extends StripePaymentMethodModelClass {}

  

  const StripePlanModelClass = digg(result, "StripePlan")

  class StripePlan extends StripePlanModelClass {}

  

  const StripeProductModelClass = digg(result, "StripeProduct")

  class StripeProduct extends StripeProductModelClass {}

  

  const StripeSubscriptionItemModelClass = digg(result, "StripeSubscriptionItem")

  class StripeSubscriptionItem extends StripeSubscriptionItemModelClass {}

  

  const StripeSubscriptionModelClass = digg(result, "StripeSubscription")

  class StripeSubscription extends StripeSubscriptionModelClass {}

  

  const StripeTaxRateModelClass = digg(result, "StripeTaxRate")

  class StripeTaxRate extends StripeTaxRateModelClass {}

  

  const StylingAuditModelClass = digg(result, "StylingAudit")

  class StylingAudit extends StylingAuditModelClass {}

  

  const StylingModelClass = digg(result, "Styling")

  class Styling extends StylingModelClass {}

  

  const SubscriptionAuditModelClass = digg(result, "SubscriptionAudit")

  class SubscriptionAudit extends SubscriptionAuditModelClass {}

  

  const SubscriptionPeriodAuditModelClass = digg(result, "SubscriptionPeriodAudit")

  class SubscriptionPeriodAudit extends SubscriptionPeriodAuditModelClass {}

  

  const SubscriptionPeriodModelClass = digg(result, "SubscriptionPeriod")

  class SubscriptionPeriod extends SubscriptionPeriodModelClass {}

  

  const SubscriptionModelClass = digg(result, "Subscription")

  class Subscription extends SubscriptionModelClass {}

  

  const SurveyAuditModelClass = digg(result, "SurveyAudit")

  class SurveyAudit extends SurveyAuditModelClass {}

  

  const SurveyModelClass = digg(result, "Survey")

  class Survey extends SurveyModelClass {}

  

  const SurveyStepAuditModelClass = digg(result, "SurveyStepAudit")

  class SurveyStepAudit extends SurveyStepAuditModelClass {}

  

  const SurveyStepElementAuditModelClass = digg(result, "SurveyStepElementAudit")

  class SurveyStepElementAudit extends SurveyStepElementAuditModelClass {}

  

  const SurveyStepElementOptionAuditModelClass = digg(result, "SurveyStepElementOptionAudit")

  class SurveyStepElementOptionAudit extends SurveyStepElementOptionAuditModelClass {}

  

  const SurveyStepElementOptionModelClass = digg(result, "SurveyStepElementOption")

  class SurveyStepElementOption extends SurveyStepElementOptionModelClass {}

  

  const SurveyStepElementOptionScoreAuditModelClass = digg(result, "SurveyStepElementOptionScoreAudit")

  class SurveyStepElementOptionScoreAudit extends SurveyStepElementOptionScoreAuditModelClass {}

  

  const SurveyStepElementOptionScoreModelClass = digg(result, "SurveyStepElementOptionScore")

  class SurveyStepElementOptionScore extends SurveyStepElementOptionScoreModelClass {}

  

  const SurveyStepElementModelClass = digg(result, "SurveyStepElement")

  class SurveyStepElement extends SurveyStepElementModelClass {}

  

  const SurveyStepModelClass = digg(result, "SurveyStep")

  class SurveyStep extends SurveyStepModelClass {}

  

  const TableSearchModelClass = digg(result, "TableSearch")

  class TableSearch extends TableSearchModelClass {}

  

  const TableSettingColumnModelClass = digg(result, "TableSettingColumn")

  class TableSettingColumn extends TableSettingColumnModelClass {}

  

  const TableSettingModelClass = digg(result, "TableSetting")

  class TableSetting extends TableSettingModelClass {}

  

  const TeamAuditModelClass = digg(result, "TeamAudit")

  class TeamAudit extends TeamAuditModelClass {}

  

  const TeamModelClass = digg(result, "Team")

  class Team extends TeamModelClass {}

  

  const TeamSurveyAuditModelClass = digg(result, "TeamSurveyAudit")

  class TeamSurveyAudit extends TeamSurveyAuditModelClass {}

  

  const TeamSurveyModelClass = digg(result, "TeamSurvey")

  class TeamSurvey extends TeamSurveyModelClass {}

  

  const TeamSurveyStepAuditModelClass = digg(result, "TeamSurveyStepAudit")

  class TeamSurveyStepAudit extends TeamSurveyStepAuditModelClass {}

  

  const TeamSurveyStepElementAnswerAuditModelClass = digg(result, "TeamSurveyStepElementAnswerAudit")

  class TeamSurveyStepElementAnswerAudit extends TeamSurveyStepElementAnswerAuditModelClass {}

  

  const TeamSurveyStepElementAnswerModelClass = digg(result, "TeamSurveyStepElementAnswer")

  class TeamSurveyStepElementAnswer extends TeamSurveyStepElementAnswerModelClass {}

  

  const TeamSurveyStepElementAuditModelClass = digg(result, "TeamSurveyStepElementAudit")

  class TeamSurveyStepElementAudit extends TeamSurveyStepElementAuditModelClass {}

  

  const TeamSurveyStepElementModelClass = digg(result, "TeamSurveyStepElement")

  class TeamSurveyStepElement extends TeamSurveyStepElementModelClass {}

  

  const TeamSurveyStepModelClass = digg(result, "TeamSurveyStep")

  class TeamSurveyStep extends TeamSurveyStepModelClass {}

  

  const TeamUserAuditModelClass = digg(result, "TeamUserAudit")

  class TeamUserAudit extends TeamUserAuditModelClass {}

  

  const TeamUserModelClass = digg(result, "TeamUser")

  class TeamUser extends TeamUserModelClass {}

  

  const TextKeyAuditModelClass = digg(result, "TextKeyAudit")

  class TextKeyAudit extends TextKeyAuditModelClass {}

  

  const TextKeyModelClass = digg(result, "TextKey")

  class TextKey extends TextKeyModelClass {}

  

  const TextValueAuditModelClass = digg(result, "TextValueAudit")

  class TextValueAudit extends TextValueAuditModelClass {}

  

  const TextValueModelClass = digg(result, "TextValue")

  class TextValue extends TextValueModelClass {}

  

  const TranslationAuditModelClass = digg(result, "TranslationAudit")

  class TranslationAudit extends TranslationAuditModelClass {}

  

  const TranslationModelClass = digg(result, "Translation")

  class Translation extends TranslationModelClass {}

  

  const TrixFileAuditModelClass = digg(result, "TrixFileAudit")

  class TrixFileAudit extends TrixFileAuditModelClass {}

  

  const TrixFileModelClass = digg(result, "TrixFile")

  class TrixFile extends TrixFileModelClass {}

  

  const UserAuditModelClass = digg(result, "UserAudit")

  class UserAudit extends UserAuditModelClass {}

  

  const UserModelClass = digg(result, "User")

  class User extends UserModelClass {}

  

  const UserRoleAuditModelClass = digg(result, "UserRoleAudit")

  class UserRoleAudit extends UserRoleAuditModelClass {}

  

  const UserRoleModelClass = digg(result, "UserRole")

  class UserRole extends UserRoleModelClass {}

  

  const VatNumberAuditModelClass = digg(result, "VatNumberAudit")

  class VatNumberAudit extends VatNumberAuditModelClass {}

  

  const VatNumberModelClass = digg(result, "VatNumber")

  class VatNumber extends VatNumberModelClass {}

  

  const WorkplaceLinkModelClass = digg(result, "WorkplaceLink")

  class WorkplaceLink extends WorkplaceLinkModelClass {}

  

  const WorkplaceModelClass = digg(result, "Workplace")

  class Workplace extends WorkplaceModelClass {}


export {AccountAudit, Account, AccountSchoolAudit, AccountSchool, AccountUserAudit, AccountUser, AuditAction, AuditAuditableType, Audit, BrainBreakAudit, BrainBreakClassStepAudit, BrainBreakClassStep, BrainBreak, ChallengeAudit, ChallengeClassStepAudit, ChallengeClassStep, Challenge, CheckInAudit, CheckInClassStepAudit, CheckInClassStep, CheckIn, ClassStatusExpansionAudit, ClassStatusExpansion, ClassStepAudit, ClassStep, ContactAudit, ContactEmailAudit, ContactEmail, ContactPhoneNumberAudit, ContactPhoneNumber, ContactPointAudit, ContactPoint, ContactRelationshipAudit, ContactRelationship, ContactRelationshipTypeAudit, ContactRelationshipType, Contact, ContactTypeAudit, ContactType, ContentAbsoluteContainerAudit, ContentAbsoluteContainer, ContentAudit, ContentPieceTypeAudit, ContentPieceType, Content, CountryAudit, Country, CountryStateAudit, CountryState, CourseAudit, CourseClassStepAudit, CourseClassStep, CourseGroupAudit, CourseGroupCourseAudit, CourseGroupCourse, CourseGroup, CourseModuleAudit, CourseModule, Course, CurrencyAudit, Currency, DialogueAudit, Dialogue, EmailTemplateAudit, EmailTemplatePreviewAudit, EmailTemplatePreviewLiquidVariableAudit, EmailTemplatePreviewLiquidVariable, EmailTemplatePreview, EmailTemplate, EvaluationGroup, EvaluationRule, InvoiceAudit, InvoiceInfoAudit, InvoiceInfo, InvoiceLineAudit, InvoiceLine, Invoice, LocaleAudit, Locale, NewsletterAudit, Newsletter, NewsletterTemplateAudit, NewsletterTemplate, NewsletterTemplateTableSearchAudit, NewsletterTemplateTableSearch, NewsletterTemplateTimeZoneStateAudit, NewsletterTemplateTimeZoneState, NotificationAudit, Notification, NotificationSettingAudit, NotificationSetting, NotificationTypeActionAudit, NotificationTypeAction, NotificationTypeAudit, NotificationTypeAuditTriggerAudit, NotificationTypeAuditTrigger, NotificationType, PageContentAudit, PageContent, PageViewAudit, PageView, PaymentMethodAudit, PaymentMethod, PlanAudit, Plan, PlanResourceAudit, PlanResourcePeriodAudit, PlanResourcePeriodPriceAudit, PlanResourcePeriodPrice, PlanResourcePeriod, PlanResource, RoleAudit, Role, SchoolAudit, SchoolClassAudit, SchoolClassBrainBreakAudit, SchoolClassBrainBreak, SchoolClassChallengeAudit, SchoolClassChallenge, SchoolClassCheckInAudit, SchoolClassCheckInEventAudit, SchoolClassCheckInEvent, SchoolClassCheckIn, SchoolClassContentPieceAudit, SchoolClassContentPiece, SchoolClassCourseAudit, SchoolClassCourseModuleAudit, SchoolClassCourseModule, SchoolClassCourse, SchoolClassGroupAudit, SchoolClassGroupClassStepAudit, SchoolClassGroupClassStep, SchoolClassGroup, SchoolClassInvitationAudit, SchoolClassInvitation, SchoolClass, SchoolContactRequestAudit, SchoolContactRequest, School, ScoreFactorAudit, ScoreFactorGroupAudit, ScoreFactorGroup, ScoreFactorGroupScoreFactorAudit, ScoreFactorGroupScoreFactor, ScoreFactor, StripeCard, StripeCharge, StripeCoupon, StripeCustomer, StripeDiscount, StripeInvoiceItem, StripeInvoice, StripePaymentIntent, StripePaymentMethod, StripePlan, StripeProduct, StripeSubscriptionItem, StripeSubscription, StripeTaxRate, StylingAudit, Styling, SubscriptionAudit, SubscriptionPeriodAudit, SubscriptionPeriod, Subscription, SurveyAudit, Survey, SurveyStepAudit, SurveyStepElementAudit, SurveyStepElementOptionAudit, SurveyStepElementOption, SurveyStepElementOptionScoreAudit, SurveyStepElementOptionScore, SurveyStepElement, SurveyStep, TableSearch, TableSettingColumn, TableSetting, TeamAudit, Team, TeamSurveyAudit, TeamSurvey, TeamSurveyStepAudit, TeamSurveyStepElementAnswerAudit, TeamSurveyStepElementAnswer, TeamSurveyStepElementAudit, TeamSurveyStepElement, TeamSurveyStep, TeamUserAudit, TeamUser, TextKeyAudit, TextKey, TextValueAudit, TextValue, TranslationAudit, Translation, TrixFileAudit, TrixFile, UserAudit, User, UserRoleAudit, UserRole, VatNumberAudit, VatNumber, WorkplaceLink, Workplace}
